export const VALIDATE_TICKETSELL_START = "VALIDATE_TICKETSELL_START";
export const VALIDATE_TICKETSELL_SUCCESS = "VALIDATE_TICKETSELL_SUCCESS";
export const VALIDATE_TICKETSELL_FAILURE = "VALIDATE_TICKETSELL_FAILURE";